import { getBusinessInfo, IBusinessInfo, updateBusinessInfo, UpdateBusinessInfo_Body } from '@/services/business-info-service';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState: BusinessInfoSliceDataType = {
  loading: false,
  isSubmitting: false,
  businessInfoData: null,
};

const businessInfoSlice = createSlice({
  name: 'businessInfo',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBusinessInfoThunk.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBusinessInfoThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.businessInfoData = action.payload;
    });
    builder.addCase(updateBusinessInfoThunk.pending, (state) => {
      state.isSubmitting = true;
    });
    builder.addCase(updateBusinessInfoThunk.fulfilled, (state, action) => {
      state.isSubmitting = false;
      state.businessInfoData = action.payload;
    });
  },
});

export default businessInfoSlice.reducer;
export interface BusinessInfoSliceDataType {
  loading: boolean;
  isSubmitting: boolean;
  businessInfoData: IBusinessInfo | null;
}

export const getBusinessInfoThunk = createAsyncThunk('businessInfo/getBusinessInfoThunk', async () => {
  const response = await getBusinessInfo();
  return response?.data?.[0] || null;
});

export const updateBusinessInfoThunk = createAsyncThunk('businessInfo/updateBusinessInfoThunk', async ({ id, newData }: { id: IBusinessInfo['_id']; newData: UpdateBusinessInfo_Body }) => {
  const response = await updateBusinessInfo({ _id: id }, newData);
  return response.data.data || null;
});
